/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A matrix: a header row of column names, a first column of row names, and numeric values in the cells. Every cell's value is mapped to a colour.`)
};

const es_heat_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una matriz: una fila de cabecera con nombres de columna, una primera columna con nombres de fila, y valores numéricos en las celdas. El valor de cada celda se asigna a un color.`)
};

const de_heat_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Matrix: eine Kopfzeile mit Spaltennamen, eine erste Spalte mit Zeilennamen und numerische Werte in den Zellen. Der Wert jeder Zelle wird auf eine Farbe abgebildet.`)
};

const nl_heat_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een matrix: een headerrij met kolomnamen, een eerste kolom met rijnamen, en numerieke waarden in de cellen. De waarde van elke cel wordt afgebeeld op een kleur.`)
};

const fr_heat_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une matrice : une ligne d'en-tête de noms de colonne, une première colonne de noms de ligne, et des valeurs numériques dans les cellules. La valeur de chaque cellule est mappée à une couleur.`)
};

const it_heat_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una matrice: una riga di intestazione di nomi di colonna, una prima colonna di nomi di riga, e valori numerici nelle celle. Il valore di ogni cella viene mappato su un colore.`)
};

const pt_br2_heat_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma matriz: uma linha de cabeçalho com nomes de colunas, uma primeira coluna com nomes de linhas, e valores numéricos nas células. O valor de cada célula é mapeado para uma cor.`)
};

const pt_heat_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma matriz: uma linha de cabeçalho com nomes de colunas, uma primeira coluna com nomes de linhas, e valores numéricos nas células. O valor de cada célula é mapeado para uma cor.`)
};

const ja_heat_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行列です: 列名のヘッダー行、行名の最初の列、そしてセル内の数値です。すべてのセルの値が色にマッピングされます。`)
};

const zh_heat_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个矩阵：一行列名表头、一列行名，以及单元格中的数值。每个单元格的数值都会映射为一种颜色。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_faq_a1", locale)
	if (locale === "en") return en_heat_faq_a1(inputs)
	if (locale === "es") return es_heat_faq_a1(inputs)
	if (locale === "de") return de_heat_faq_a1(inputs)
	if (locale === "nl") return nl_heat_faq_a1(inputs)
	if (locale === "fr") return fr_heat_faq_a1(inputs)
	if (locale === "it") return it_heat_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_heat_faq_a1(inputs)
	if (locale === "pt") return pt_heat_faq_a1(inputs)
	if (locale === "ja") return ja_heat_faq_a1(inputs)
	return zh_heat_faq_a1(inputs)
};